/**
 * Kriptonio.Rpc.Rest, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EndpointCallStatus = 'Success' | 'Error';

export const EndpointCallStatus = {
    Success: 'Success' as EndpointCallStatus,
    Error: 'Error' as EndpointCallStatus
};

